import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-1414738370__a" }, [
        _createElementVNode("rect", {
          width: "20",
          height: "20",
          rx: "0"
        })
      ])
    ], -1),
    _createElementVNode("g", { "clip-path": "url(#i-1414738370__a)" }, [
      _createElementVNode("path", {
        fill: "#743A3A",
        d: "M11.375 10.35c0-.368.126-.726.356-1.014l3.562-4.453a.375.375 0 0 0 .082-.234V4A.375.375 0 0 0 15 3.625H5A.375.375 0 0 0 4.625 4v.65c0 .084.029.167.082.233L8.27 9.336c.23.288.356.646.356 1.015v5.031c0 .142.08.272.207.335l2.543 1.272V10.35h-.001ZM5 2.376h10c.897 0 1.625.728 1.625 1.625v.65c0 .368-.126.726-.356 1.014l-3.562 4.453a.375.375 0 0 0-.082.234v6.84c0 .836-.88 1.38-1.628 1.006l-2.724-1.362a1.625 1.625 0 0 1-.898-1.453v-5.031a.375.375 0 0 0-.082-.234L3.73 5.664a1.625 1.625 0 0 1-.356-1.015V4c0-.897.728-1.625 1.625-1.625L5 2.376Z"
      })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "filters2"}) } }